import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { titlevalidation } from "../../../Common/commonvalidation";

export default function ModalTitle({
  title,
  setModaltitle,
  hitApi,
  handleInputTitle,
}) {
  const initialValues = {
    title: title || "",
  };

  const validationSchema = Yup.object().shape({
    title: titlevalidation
  });

  const handleSubmit = (values) => {
    setModaltitle((state) => !state);
    hitApi();
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {() => (
        <>
          <button
            onClick={() => setModaltitle((state) => !state)}
            className="btn close-button"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt=""
            />
          </button>
          <Form>
            <ModalBody>
              <h4>Edit Title</h4>
              <div className="form-group">
                <label className="label-s">Enter Title</label>
                <Field name="title">
                  {({ field }) => (
                    <input
                      {...field}
                      className="form-control input"
                      type="text"
                      placeholder="Your Title"
                      onChange={(e) => {
                        field.onChange(e); // Fix cursor jump by letting Formik manage its own state change
                        if (handleInputTitle) handleInputTitle(e); // Sync the parent state without reinitializing Formik
                      }}
                    />
                  )}
                </Field>
                <ErrorMessage name="title" component="div" className="error" />
              </div>
            </ModalBody>
            <div className="modal-footer ">
              <button className="btn" type="submit">
                Save
              </button>
            </div>
          </Form>
        </>
      )}
    </Formik>
  );
}
